<template>
  <form-layout class="form-layout">
    <span slot="title">委托发货单</span>
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" slot="apply-box" :inline="true">
      <el-form-item label="收件人" prop="ContactName">
        <el-input class="form-input" v-model="ruleForm.ContactName" placeholder="联系人姓名"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="ContactPhone">
        <el-input class="form-input" v-model="ruleForm.ContactPhone" placeholder="联系人电话"></el-input>
      </el-form-item>
      <br>
      <el-form-item label="联系地址" type="flex" justify="space-between" style="width: 600px" prop='StreetAddress'>
        <address-box
          :province-id.sync="ruleForm.ProvinceId"
          :city-id.sync="ruleForm.CityId"
          :county-id.sync="ruleForm.CountyId"
          :point-id.sync="ruleForm.PointOfSalesId"
          :address.sync="ruleForm.StreetAddress"
        ></address-box>
      </el-form-item>
    </el-form>
    <div class="table_area" slot="main-content">
      <div class="item-box" v-for="(item, index) in invoicebox">
        <table>
          <thead>
            <tr>
              <td width="260">物料名称</td>
              <td width="260">客户物料名称</td>
              <td width="100">品项</td>
              <td width="80">品牌</td>
              <td width="80">机型</td>
              <td width="80">模块</td>
              <td width="60">库存</td>
              <td width="80">数量</td>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td>
                {{item.ProductName}}<br>
                物料编码：{{item.ProductCode}}
              </td>
              <td>
                {{item.ProductName}}<br>
                客户物料编码：{{item.ProductCode}}
              </td>
              <td>
                <el-tag :type="item.ConditionName | ConditionColor">{{item.ConditionName}}</el-tag>
              </td>
              <td>
                {{item.ProductBrandName}}
              </td>
              <td>
                {{item.ProductModelName}}
              </td>
              <td>
                {{item.ProductModuleName}}
              </td>
              <td>
                {{item.Quantity}}
              </td>
              <td>
                <el-input placeholder="数量" v-model.number="item.number"></el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <el-button class="delete-btn" @click.native="deleteItem(item, index)">X</el-button>
      </div>
    </div>
    <div class="sumbit_box" slot="sumbit_box">
      <el-form  :inline="true" style="display:inline;">
        <el-form-item label="备注">
          <el-input type="textarea" class="form-input" v-model="notes" placeholder="请输入备注" style="width:600px;"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" class="pull-right" @click.native="submit">提交并等待客服联系</el-button>
      <el-button class="pull-right">取消</el-button>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from '@/components/pages/Inventory/FormLayout'
import AddressBox from '@/components/common/Address'
import o from '@/odata'
import { Loading } from 'element-ui'
export default {
  data() {
    return {
      ruleForm: {
        Name: null,
        Phone: null,
        ContactName: null,
        ContactPhone: null,
        ShipToPointOfSales: true,
        ProvinceId: null,
        CityId: null,
        CountyId: null,
        StreetAddress: null,
        PointOfSalesId: null,
        DeliveryManId: null,
        FacilityId: null,
      },
      rules: {
        ContactName: [{required: true, message: '必填'}],
        ContactPhone: [{required: true, message: '必填'}],
        // StreetAddress: [{required: true, message: '必填'}],
      },
      notes: null,
      invoicebox: [],
      sumbitbox: [],
    }
  },
  methods: {
    initData: function() {
      this.invoicebox = JSON.parse(window.localStorage.getItem('invoicebox'))
      for (var a = 0; a < this.invoicebox.length; a++) {
        this.invoicebox[a].number = 1
      }
    },
    deleteItem: function(item, index) {
      this.$confirm('是否确认删除?', '删除批次', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.invoicebox.splice(index, 1)
        window.localStorage.setItem('invoicebox', JSON.stringify(this.invoicebox))
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    submit: function() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let loading = Loading.service({text: '正在提交订单,请稍后', customClass: 'comfirmLoading'})
          for (var a = 0; a < this.invoicebox.length; a++) {
            this.sumbitbox.push({
              ProductId: this.invoicebox[a].ProductId,
              ConditionId: this.invoicebox[a].ConditionId,
              Quantity: this.invoicebox[a].number,
            })
          }
          const Invoice = o('OutStockPicking')
          const form = {
            ContactName: this.ruleForm.ContactName,
            ContactPhone: this.ruleForm.ContactPhone,
            ContactEmail: this.ruleForm.ContactEmail,
            ReferenceCode: this.ruleForm.ReferenceCode,
            Notes: this.notes,
            Lines: this.sumbitbox,
          }
          Invoice.post(form).save().then((response) => {
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            loading.close()
            this.invoicebox = []
            window.localStorage.setItem('invoicebox', JSON.stringify(this.invoicebox))
            this.$router.push('/trust')
          }).catch((response) => {
            loading.close()
          })
        }
      })
    },
  },
  components: {
    FormLayout,
    AddressBox,
  },
  created() {
    this.initData()
  },
}
</script>

<style lang="less" scoped>
.table_area table tbody td{
  padding-right: 5px;
}
.form-input {
  width: 260px;
}
.list-layout .complex-table .sub-row-table .sub-body .text-center{
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.add-btn:hover,.add-btn:focus{
  color: #FFFFFF;
  background: #2283CA;
}
.item-box{
  position: relative;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 25px;
  border: 1px solid #E1E8EE;
  width: 90%;
  .el-select,.el-input{
    width: 100%;
  }
  .delete-btn{
    position: absolute;
    right: -60px;
    top: 35%;
    background-color: #FF4949;
    color: #fff;
    padding: 10px 12px;
    border-radius: 50%;
    border: none;
  }
  table{
    display: inline-block;
    label{
      display: block;
      margin-bottom: 5px;
    }
    td{
      padding-right: 20px;
    }
    td:last-child{
      padding-right: 0;
    }
  }
}
.sumbit_box{
  margin-top: 20px;
  p{
    text-align: right;
    font-size: 18px;
    color:  #1F2D3D;
    span{
      color: #FF4949;
    }
  }
  .el-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ManagedShipPage.vue?2b55e485